import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"

const TaxExemptions = ({ setAddNewTaxExemption }) => {
  const tableData = [
    { excemptionName: "Books Exemption", taxType: "VAT", appliesTo: "Books (Product Category)", effectiveDate: "2024-01-01" },
    { excemptionName: "Books Exemption", taxType: "VAT", appliesTo: "Books (Product Category)", effectiveDate: "2024-01-01" },
  ]

  const columns = [
    {
      name: "Exemption Name",
      selector: (row) => row.excemptionName,
    },
    {
      name: "Tax Type",
      selector: (row) => row.taxType,
    },
    {
      name: "Applies to",
      selector: (row) => row.appliesTo,
    },
    {
      name: "Effective Date",
      selector: (row) => row.effectiveDate,
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex gap-2">
          <div>
            <button style={{ all: "unset" }}>Edit</button>
          </div>
          <div>
            <button style={{ all: "unset" }}>Deactivate</button>
          </div>
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow rounded-top mt-3">
        <div className="fw-semibold fs-5">Product Specific Tax Rule</div>
        <DynamicButton theme="blue" onClick={() => setAddNewTaxExemption((prev) => !prev)}>
          Add New
        </DynamicButton>
      </div>

      <DynamicDatatable data={tableData} columns={columns} type="yellow" />
    </>
  )
}

export default TaxExemptions
